import { Nav } from 'react-bootstrap';
import { NavItemWrapper } from '../styles';

interface IProps {
    section: string,
    tabText: string,
    centerId: number,
    centerAlias: string,
}

const NavDonorCenter = (props: IProps) => {
    const { section, tabText, centerId, centerAlias } = props;
    const hrefPrefix = `/center/${centerId}/billing`;
    const tabWidth = '230';

    return (
        <div style={{ padding: 20, backgroundColor: 'white' }}>
            <Nav bsStyle='pills' className='acc-pills'>

                <NavItemWrapper active={section == 'PENDING'} href={hrefPrefix + '/pending'} tabWidth={tabWidth}>
                    Pending Billing
                </NavItemWrapper>

                <li role='presentation'><span>|</span></li>

                <NavItemWrapper active={section == 'BILLED-BY-CENTER'} href={hrefPrefix + '/billed-by-center'} tabWidth={tabWidth}>
                    Billed by {centerAlias}
                </NavItemWrapper>

                <li role='presentation'><span>|</span></li>

                <NavItemWrapper active={section == 'NOT-BILLED'} href={hrefPrefix + '/not-billed'} tabWidth={tabWidth}>
                    Not Billed
                </NavItemWrapper>

                <li role='presentation'><span>|</span></li>

                <NavItemWrapper active={section == 'BILLED-MANUALLY'} href={hrefPrefix + '/billed-manually'} tabWidth={tabWidth}>
                    Billed Manually
                </NavItemWrapper>

                <li role='presentation'><span>|</span></li>

                <NavItemWrapper active={section == 'SEARCH'} href={hrefPrefix + '/ar-search'} tabWidth={tabWidth}>
                    Search
                </NavItemWrapper>

                {section.toUpperCase() == 'VIEW-EDIT' && (
                    <>
                        <li role='presentation'><span>|</span></li>
                        <NavItemWrapper active={section == 'VIEW-EDIT'} tabWidth={tabWidth}>
                            {tabText}
                        </NavItemWrapper>
                    </>
                )}

                {section.toUpperCase() == 'VIEW-CHARGES' && (
                    <>
                        <li role='presentation'><span>|</span></li>
                        <NavItemWrapper active={section == 'VIEW-CHARGES'} tabWidth={tabWidth}>
                            {tabText}
                        </NavItemWrapper>
                    </>
                )}
            </Nav>
        </div>
    );
}

export default NavDonorCenter;